
export { findInputError } from './findInputError'
export { isFormInvalid } from './isFormInvalid'
export const serviceTypes = [{
    "id": "1",
    "name": "agro",
    "title": "Agrovet Services",
    "subtitle": "Sell farm products",
    "url": "/select-products",
    "serviceType": "AGRODEALER",
    "action": "Buy"
},
{
    "id": "2",
    "name": "school",
    "title": "School Fees",
    "subtitle": "Pay school fees easily here",
    "url": "/school-fees",
    "serviceType": "SCHOOL",
    "action": "Pay"
},
{
    "id": "3",
    "name": "nhif",
    "title": "NHIF/SHIF",
    "subtitle": "Pay NHIF easily here",
    "url": "/select-products",
    "serviceType": "NHIF_SHIF",
    "action": "Pay"
},
{
    "id": "4",
    "name": "vet",
    "title": "Veterinary Services",
    "subtitle": "Offer vet services",
    "url": "/select-products",
    "serviceType": "VETERINARIAN",
    "action": "Buy"
},
{
    "id": "5",
    "name": "shop",
    "title": "Shop",
    "subtitle": "Sell farm products",
    "url": "/select-products",
    "serviceType": "SHOP",
    "action": "Sell"
}
]
export const subCounties = [
    {
        "SUBCOUNTY_NAME": "GATANGA",
        "TOTAL_AMOUNT": 0
    },
    {
        "SUBCOUNTY_NAME": "MARAGWA",
        "TOTAL_AMOUNT": 0
    },
    {
        "SUBCOUNTY_NAME": "KANDARA",
        "TOTAL_AMOUNT": 0
    },
    {
        "SUBCOUNTY_NAME": "KIGUMO",
        "TOTAL_AMOUNT": 0
    },
    {
        "SUBCOUNTY_NAME": "MATHIOYA",
        "TOTAL_AMOUNT": 0
    },
    {
        "SUBCOUNTY_NAME": "KANGEMA",
        "TOTAL_AMOUNT": 0
    },
    {
        "SUBCOUNTY_NAME": "KIHARU",
        "TOTAL_AMOUNT": 0
    }
]
export const filterByProductType = (array, type) => {
    if (!type) {
        return array;
    } else {
        return array.filter(item => item.productType === type);
    }
}


export const dateFormatter = (inputDate) => {
    if (inputDate !== null && inputDate !== "") {
        const dateObject = new Date(inputDate);
        const day = dateObject.getUTCDate();
        const monthIndex = dateObject.getUTCMonth();
        const year = dateObject.getUTCFullYear();
        const monthNames = [
            "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
            "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
        ];
        const monthName = monthNames[monthIndex];
        return `${(day.toString().length == 1 ? `0`+day : day) }-${monthName}-${year}`;
    }
    return null
    
}

